import React from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const BACKDROP_ANIMATION = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.5, ease: 'easeOut' }
};

const PANEL_ANIMATION = {
  initial: { opacity: 0, y: -20, scale: 0.98 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -10, scale: 0.98 },
  transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] }
};

const linkAnimation = (index) => ({
  initial: { opacity: 0, x: -10 },
  animate: { opacity: 1, x: 0 },
  transition: { delay: 0.05 + index * 0.04, duration: 0.3, ease: 'easeOut' }
});

const MenuOverlay = ({ isOpen, onClose, navLinks }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            {...BACKDROP_ANIMATION}
            className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"
            onClick={onClose}
          />
          {/* Menu Panel */}
          <motion.div
            {...PANEL_ANIMATION}
            className="fixed top-0 left-0 h-full w-72 md:w-80 z-50 bg-[#D4C5B0] shadow-2xl"
            data-testid="menu-overlay"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-black/70 hover:text-black transition-colors duration-300"
              data-testid="menu-close-btn"
              aria-label="Close menu"
            >
              <X size={20} />
            </button>

            <div className="pt-16 pb-10 px-6 md:px-8">
              <div className="flex flex-col gap-4">
                {navLinks.map((link, index) => (
                  <motion.div key={link.to} {...linkAnimation(index)}>
                    <Link
                      to={link.to}
                      onClick={onClose}
                      className="block font-serif text-lg md:text-xl text-black hover:text-black/60 transition-colors duration-300 py-1"
                      data-testid={`menu-link-${link.to.slice(1)}`}
                    >
                      {link.label}
                    </Link>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default MenuOverlay;
